// THIS ONLY FOR EXAMPLE
import { atom } from "recoil";

const exampleUsAtom = atom({
  key: "exampleUsState",
  default:
    "😎 This message comes from exampleUsAtom.js in the atoms folder, click on the logo that levitates above. ☝🏼☝🏼",
});

export default exampleUsAtom;
